import axios from 'axios';
import {ActionTree} from 'vuex';
import {RootState} from '@/store/types';
import {SmsTemplateItem, TemplatesState, TemplatesFilterParams} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<TemplatesState, RootState> = {
  getSmsTemplates: ({commit, dispatch}, data: TemplatesFilterParams) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/sms/templates',
        params: data,
      })
        .then((resp:any) => {
          commit('setSmsTemplates', resp.data.templates);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
  exportSmsTemplates: ({commit, dispatch}, data: TemplatesFilterParams) => {
    return directDownload('/sms/templates/export', data)
  },
  getSmsMultichannelTemplates: ({commit, dispatch}, data: any) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/${data.transport}/templates`,
        params: data.filter
      })
        .then((resp:any) => {
          commit('setSmsMultichannelTemplates', resp.data.templates);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
  getSmsTemplateItem: ({commit, dispatch}, id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `sms/templates/${id}`,
        params: {cache: Math.random()},
      })
        .then((resp:any) => {
          let smsItem = <SmsTemplateItem>resp.data;
          smsItem.ttl = smsItem.ttl ? smsItem.ttl / 3600 : null
          smsItem.id = id;
          commit('setSmsTemplateItem', smsItem);
          resolve(smsItem)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
  saveSmsTemplate: ({commit, dispatch}, data: SmsTemplateItem) => {
    return new Promise((resolve, reject) => {
      data.ttl = data.ttl ? data.ttl * 3600 : null
      data.send_evenly = data.send_evenly ?? 0
      data.save_text = data.save_text ?? 0
      axios({
        method: data.id ? 'put' : 'post',
        url: '/sms/templates/' +  (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getSmsTemplates');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
  deleteSmsTemplate: ({commit, dispatch}, data: SmsTemplateItem) => {
    return new Promise((resolve, reject) => {
      let editId = '';
      if (!data.id) {return}
      editId = data.id.toString();
      axios({
        method: 'delete',
        url: '/sms/templates/'+editId,
        data: data
      })
        .then((resp:any) => {
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
};